export default "__VITE_ASSET__DXnj7pWt__"